import store from '@/store';
import otherCryptoCurrency from '@/store/modules/otherCryptoCurrency';

store.registerModule('otherCryptoCurrency', otherCryptoCurrency);

export default store;
